/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.18 baseball.gltf -t -T 
Files: baseball.gltf [10.7KB] > C:\Users\Zac\rsenal-app\public\models\balls\baseball-transformed.glb [3.26MB] (-30343%)
*/

import * as THREE from 'three'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'

type GLTFResult = GLTF & {
  nodes: {
    ball: THREE.Mesh
    centersphere: THREE.Mesh
    seam: THREE.Mesh
  }
  materials: {
    ['ball_mat.001']: THREE.MeshStandardMaterial
    ['center.001']: THREE.MeshStandardMaterial
    ['seam_mat.001']: THREE.MeshStandardMaterial
  }
}

// @ts-ignore
export function Baseball(props: JSX.IntrinsicElements['group']) {
  // @ts-ignore
  const { nodes, materials } = useGLTF('/models/balls/baseball.glb') as GLTFResult
  return (
    <group {...props}  rotation={[Math.PI/2, 0, Math.PI/2]} dispose={null}>
      <group scale={3.281} position={[0 * 3.281, -.037 * 3.281, .008 * 3.281]} >
        <mesh geometry={nodes.ball.geometry} material={materials['ball_mat.001']} scale={1} />
        <mesh geometry={nodes.seam.geometry} material={materials['seam_mat.001']} scale={1} />
      </group>
    </group>
  )
}

useGLTF.preload('/models/balls/baseball.glb')
